import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { JournalEntryReportItemTemplate } from '@app/models/payroll/journal-entry-reports-settings-line-item.model';
import { JournalEntryReportItemTemplateCategories } from '@app/modules/settings/enums/journal-entry-report-line-item-categories.enum';

@Component({
    selector: 'journal-entry-report-settings-line-items-form',
    templateUrl: './journal-entry-report-settings-line-items-form.template.html',
    styleUrls: ['./journal-entry-report-settings-line-items-form.style.scss'],
})
export class JournalEntryReportSettingsLineItemsForm implements OnChanges {
    @Input() journalEntryReportItemTemplates: JournalEntryReportItemTemplate[] = [];
    @Output()
    journalEntryReportTemplateChange: EventEmitter<JournalEntryReportItemTemplate> =
        new EventEmitter<JournalEntryReportItemTemplate>();

    incomeTypeJournalEntryReportLineItems: JournalEntryReportItemTemplate[] = [];
    deductionsJournalEntryReportLineItems: JournalEntryReportItemTemplate[] = [];
    benefitsJournalEntryReportLineItems: JournalEntryReportItemTemplate[] = [];

    ngOnChanges(): void {
        this.categorizeJournalEntryReportItemTemplates();
    }

    onReportItemTemplateChange(journalEntryReportItemTemplate: JournalEntryReportItemTemplate): void {
        this.journalEntryReportTemplateChange.emit(journalEntryReportItemTemplate);
    }

    isDisabled(journalEntryReportItemTemplate: JournalEntryReportItemTemplate): boolean {
        return !journalEntryReportItemTemplate.canSeparate;
    }

    private categorizeJournalEntryReportItemTemplates(): void {
        if (!this.journalEntryReportItemTemplates.length) {
            return;
        }
        this.incomeTypeJournalEntryReportLineItems = this.journalEntryReportItemTemplates.filter(
            (journalEntryReportItem) =>
                journalEntryReportItem.category === JournalEntryReportItemTemplateCategories.IncomeType
        );
        this.deductionsJournalEntryReportLineItems = this.journalEntryReportItemTemplates.filter(
            (journalEntryReportItem) =>
                journalEntryReportItem.category === JournalEntryReportItemTemplateCategories.Deductions
        );
        this.benefitsJournalEntryReportLineItems = this.journalEntryReportItemTemplates.filter(
            (journalEntryReportItem) =>
                journalEntryReportItem.category === JournalEntryReportItemTemplateCategories.Benefits
        );
    }
}
